import Vue from 'vue'
import App from './App.vue'
import './assets/index.css';

// require('./assets/sass/main.scss');
require('vue2-animate/dist/vue2-animate.min.css')

// Vue TimeLine
import VueTimeline from "@growthbunker/vuetimeline";
Vue.use(VueTimeline, {
  // Specify the theme to use: dark or light (dark by default).
  theme: "dark",
});

// Vue 3D Carousel
import Carousel3d from 'vue-carousel-3d'
Vue.use(Carousel3d)
//Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faCircleNotch, faFileSignature, faCopyright,
  faArrowAltCircleRight,  faProjectDiagram,
  faMoon, faSun, faLayerGroup
} from '@fortawesome/free-solid-svg-icons'
library.add(
  faCircleNotch, faFileSignature, faCopyright,
  faArrowAltCircleRight, faProjectDiagram,
  faSun, faMoon, faLayerGroup
)
Vue.component('fa', FontAwesomeIcon)
// Vuex
import {store} from './vuex/store'
// Router
import router from './router'
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
